// extracted by mini-css-extract-plugin
module.exports = {"container":"bAX0WiHJMFY1DSEm66Ttm","visible":"P4tsk10DyADAAj_tSmd_h","cancelBtn":"_3N5kzIfv0U2dX1BAJqwaov","icon":"_1WpNggdDH772IoB_lmIMWY","saveBtn":"BoLkXWjhgJi1US2jPbvfd"};